module.exports = __webpack_public_path__ + "h5/img/banner1.7b45181c.png";